
import { Options, Vue } from 'vue-class-component';
import { mapMutations, mapState } from 'vuex';

@Options({
  computed: mapState(['isLogged', 'currentView']),
  methods: mapMutations(['SET_CURRENT_VIEW']),
})
export default class MobileNav extends Vue {
  SET_CURRENT_VIEW!: (view: string) => void;

  goHome(): void {
    this.$router.push({ name: 'Home' });
    this.SET_CURRENT_VIEW('Home');
  }

  goSearch(): void {
    this.$router.push({ name: 'Search' });
    this.SET_CURRENT_VIEW('Search');
  }

  goStats(): void {
    this.$router.push({ name: 'Stats' });
    this.SET_CURRENT_VIEW('Stats');
  }

  goProfile(): void {
    this.$router.push({ name: 'Profile' });
    this.SET_CURRENT_VIEW('Profile');
  }

  createQuiz(): void {
    this.$router.push({ name: 'CreateQuiz' });
    this.SET_CURRENT_VIEW('');
  }
}
